/**
 * Find the Trace-ID from the server timing API
 * @returns {string}
 */
export function getTraceId() {
    if (typeof performance === 'undefined') {return;}
    if (typeof performance.getEntriesByType !== 'function') {return;}
    const navigation = performance.getEntriesByType('navigation');
    if (!navigation) {return;}
    if (navigation.length === 0) {return;}
    const { serverTiming } = navigation.pop();
    if (!serverTiming) {return;}
    const traceIdEntry = serverTiming.find(
        ({ name }) => name === 'Trace-ID'
    );
    if (!traceIdEntry) {return;}
    return traceIdEntry.description;
}
